"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSPersonalInformationComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const generic_content_service_1 = require("../../services/generic.content.service");
const constants = require("../../../shared/constants");
class CSHSPersonalInformationComponent {
    constructor(accountDetailService, modalService, genericContentService, accountService) {
        this.accountDetailService = accountDetailService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.ownerType = constants.ownerType;
        this.sbiType = constants.sbiType;
        this.stateList = [
            { name: 'Alabama', value: 'AL' },
            { name: 'Florida', value: 'FL' },
            { name: 'Mississippi', value: 'MS' },
            { name: 'Tennessee', value: 'TN' }
        ];
        this.sendPersonalInfo = new core_1.EventEmitter();
    }
    open(content, options = { windowClass: 'dark-modal' }) {
        this.modelRef = this.modalService.open(content, options);
    }
    ngOnInit() {
        this.getAccountInformationDetails();
        this.showForm = true;
        this.getErrorMessage();
    }
    openNameChange() {
        this.open(this.nameModelContent);
        this.loading = true;
        this.genericContentService.getGenericContent('/generic/instructional/ChangeAccountName')
            .subscribe((content) => {
            this.accountChangeContent = content;
            this.loading = false;
        }, (err) => {
            this.modelError = err;
            this.loader = false;
        });
    }
    getAccountInformationDetails() {
        this.loader = true;
        this.accountDetailService.getHomeServicePersonalInformation().subscribe((accountInfo) => {
            this.loader = false;
            this.personalInfo = accountInfo;
            this.sendPersonalInfo.emit(this.personalInfo);
            this.personalInfo.billingAddress.zip = this.personalInfo.billingAddress.zip.substr(0, 5);
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    submitPersonalInfo(value) {
        this.loader = true;
        this.error = null;
        this.accountDetailService.validateHomeServicePersonalInfo(value)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.showForm = true;
            this.getAccountInformationDetails();
            this.EditForm = false;
            // if (res.error !== undefined) {
            //     this.errorMsg = res.error;
            // } else {
            //     this.EditForm = false;
            // }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    showEditForm() {
        this.showForm = !this.showForm;
        this.error = null;
        // call account info
        if (this.showForm) {
            this.getAccountInformationDetails();
        }
    }
}
exports.CSHSPersonalInformationComponent = CSHSPersonalInformationComponent;
//# sourceMappingURL=hspersonalinformation.component.js.map